import _ from 'lodash';
import React from 'react';
import TextBox from '../../../../ui/TextBox';
import CheckBox from '../../../../ui/CheckBox';

import {ApplicableTableSettings, mblSelectContainer} from '../../../../tableSettings';

import SmartTable from '../../../../uiControls/SmartTable';

import MblMilestoneContainerStatus from './MblMilestoneContainerStatus';
import InlineInputControlRow from "../../../../ui/layout/InlineInputControlRow";
import {OeMbl} from "../../../../fms.core/OeMbl";
import {OmContainer} from "../../../../fms.core/OmContainer";
import {OceanMblStatusMap} from "../../../../fms.core/MblStatusViewModel";
import {PimsCntrEvent} from "../../../../fms.core/PimsCntrEvent";
import Date from "../../../../ui/Date";
import BlueTitleRow from "../../../../ui/BlueTitleRow";
import { TextAlignLeftRenderer } from '../../../../uiControls/SmartTableRenderers';
import useTableStorage from '../../../../hooks/useTableStorage';
import { getOriginalValue } from '../../../../fms.core/data/TrackingModule';

function SelectRenderer({data, row}: any) {
  const toggleSelection = data[0].toggleSelection;
  const selectedIndex = data[0].selectedIndex;
  const isView = data[0].isView;

  return <div className="ifms-table-default"><CheckBox value={selectedIndex === row.index} onChange={() => toggleSelection(row.index)} disabled={isView}/></div>;
}

export type OeMblMilestoneHandle = {
  executeApplyToAll: VoidFunction,
};

type MblMilestoneProps = {
  mbl: OeMbl,
  onChange: (x: Partial<OeMbl>) => void,
  containerInfo: OmContainer[],
  onContainerInfoChange: (x: OmContainer[]) => void,
  isView: boolean,
  user: string,
};

const MblMilestoneImpl: React.ForwardRefRenderFunction<OeMblMilestoneHandle, MblMilestoneProps> =({
  mbl,
  onChange,
  containerInfo,
  onContainerInfoChange,
  isView,
  user,
}, ref) => {
  React.useImperativeHandle(ref, () => ({
    executeApplyToAll: () => {
      const status = selectedIndex >= 0 && selectedIndex < containerInfo.length ? mbl.milestone?.eventItemList?.filter(v => v.cntrNo === containerInfo[selectedIndex].containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === containerInfo[selectedIndex].pimsLinkId )) ?? null : null;
      if (status) {
        applyContainerStatusToAll(status);
      }
    },
  }));

  const tableStorage = useTableStorage();
  const selectedIndex = mbl.milestoneContainerSelectedIndex || 0;

  function setSelectedIndex(milestoneContainerSelectedIndex: number) {
    onChange({milestoneContainerSelectedIndex});
  }

  function toggleSelection(index: number) {
    setSelectedIndex(selectedIndex === index ? -1 : index);
  }

  function onContainerStatusChange(cntrIndex: number, status: Array<PimsCntrEvent>, select: boolean) {
    const update = _.cloneDeep(containerInfo);
    status.forEach(s => {
      const omCntr = update[cntrIndex];

      const pimsCntr = mbl.milestone?.cntrItemList.find(x => x.cntrNo === s.cntrNo || (x.id > 0 && x.id === s.pimsCntrId));

      const msitem = OceanMblStatusMap.get(s.seq);

      if (msitem?.cntrDate) {
        const cntrDateToSet = !select ? getOriginalValue(mbl.container[cntrIndex], msitem.cntrDate) : s.datetime;
        if (omCntr) _.set(omCntr, msitem.cntrDate, cntrDateToSet);
        if (pimsCntr && msitem.pimsCntrDate) _.set(pimsCntr, msitem.pimsCntrDate, cntrDateToSet);
      }
      if (msitem?.cntrLoc) {
        const locToSet = !select ? getOriginalValue(mbl.container[cntrIndex],msitem.cntrLoc) : s.locName;
        if (omCntr) _.set(omCntr, msitem.cntrLoc, locToSet);
        if (pimsCntr && msitem.pimsCntrLoc) _.set(pimsCntr, msitem.pimsCntrLoc, locToSet);
      }
    });

    onContainerInfoChange(update);
  }

  function applyContainerStatusToAll(status: Array<PimsCntrEvent>) {
    const update = _.cloneDeep(containerInfo);

    // collect valid events
    // const statusUpdate = //[save-sqlinfo]status.filter((s:MilestoneContainerInfoStatus) => s.date && s.time);
    //   status.filter(s => s.datetime);
    const statusUpdateWithIndices = status.map((status, index) => ({status, index})).filter(s => s.status.datetime);
    const updatedProps = _.keys(update[selectedIndex]).filter(x => (
      x.endsWith('Date') ||
      x.endsWith('Loc') ||
      x.endsWith('ord') ||
      x.endsWith('atd') ||
      x.endsWith('ata')
      // || x.endsWith('carrierRls') ||
      // x.endsWith('customRls') ||
      // x.endsWith('rAtd') ||
      // x.endsWith('rAta') ||
      // x.endsWith('emptyReturn')
    ) && !!(update[selectedIndex] as any)[x]);

    update.forEach((x, i) => {
      if (i === selectedIndex) {
        return;
      }

      updatedProps.forEach(u => {
        (x as any)[u] = (update[selectedIndex] as any)[u];
      });

      if (mbl.milestone && mbl.milestone.eventItemList) {

        const itemList = mbl.milestone.eventItemList.filter(v => v.cntrNo === x.containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === x.pimsLinkId));

        statusUpdateWithIndices.forEach(si => {
          if (itemList.length > si.index) {
            itemList[si.index].date = si.status.date;
            itemList[si.index].datetime = si.status.datetime;
            itemList[si.index].time = si.status.time;
            itemList[si.index].locName = si.status.locName;
          }
        })
      }
    })

    //<save-sqlinfo
    // update.lineItems.forEach((x:ContainerInfoLineItem) => {
    //   statusUpdate.forEach((u:MilestoneContainerInfoStatus) => {
    //     const i = x.milestone.status.findIndex((ms:MilestoneContainerInfoStatus) => ms.statusName === u.statusName);
    //     if (i >= 0) {
    //       x.milestone.status[i] = {...x.milestone.status[i], ...u};
    //     }
    //   });
    // });
    // update.forEach(x => {
    //   statusUpdate.forEach(u => {
    //     const i = mbl.milestone?.eventItemList?.findIndex(ms => ms.name === u.name && (ms.cntrNo === x.containerNo || (ms.pimsCntrId  > 0 && ms.pimsCntrId === x.pimsLinkId))) ?? -1;
    //     if (i >= 0) {
    //       mbl.milestone?.eventItemList?.splice(i, 1, {...mbl.milestone?.eventItemList[i], ...u} as PimsCntrEvent);
    //     }
    //   });
    // });
    //save-sqlinfo>

    onContainerInfoChange(update);
    setSelectedIndex(-1);
  }


  const tableOptions: ApplicableTableSettings = {
    tableName: 'oe-mblSelectContainer',
    ...mblSelectContainer,
    height: '135px',
    data: mbl.milestone?.cntrItemList?.map((x, i) => ({...x, i, toggleSelection, selectedIndex, isView})) || [],
    rowRenderers: [
      {accessor: 'select', Cell: SelectRenderer},
      {accessor: 'cntrNo', Cell: TextAlignLeftRenderer},
      {accessor: 'cntrType', Cell: TextAlignLeftRenderer},
    ],
    customStorage: tableStorage,
  };

  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{marginLeft: '40px', width: '190px'}}>
          <InlineInputControlRow label="MBL #" bold mode="w80">
            <TextBox disabled value={mbl.mblNo ?? ''} />
          </InlineInputControlRow>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>Select Container (must select before update)</span>} />
      </div>

      <div style={{display: 'flex'}}>
        <div style={{display: 'flex', width: '310px'}}>
          <div style={{width: '230px'}}>
            <SmartTable {...tableOptions} />
          </div>
        </div>

        <div style={{marginLeft: '50px', width: '320px'}}>
          <InlineInputControlRow label="Loading Port" mode="smaller-2x">
            <TextBox value={mbl.loadingPort ?? ''} disabled/>
          </InlineInputControlRow>

          <InlineInputControlRow label="Discharge Port" mode="smaller-2x">
            <TextBox value={mbl.discharge ?? ''} disabled/>
          </InlineInputControlRow>

          <InlineInputControlRow label="ETA" mode="smaller-2x">
            <div style={{width: '80px'}}>
              <Date value={mbl.eta} disabled hideIcon />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="Delivery Port" mode="smaller-2x">
            <TextBox value={mbl.finalDestination ?? ''} disabled/>
          </InlineInputControlRow>

          <InlineInputControlRow label="Vessel Name" mode="smaller-2x">
            <TextBox value={mbl.vessel ?? ''} disabled/>
          </InlineInputControlRow>

          <InlineInputControlRow label="Receiving Warehouse" mode="smaller-2x">
            <TextBox value={mbl.rstationName ?? ''} disabled/>
          </InlineInputControlRow>

          <InlineInputControlRow label="Pickup #" mode="smaller-2x">
            <TextBox value={mbl.milestone?.pickUpNo} onChange={(e) => onChange({milestone: _.merge(mbl.milestone, {pickUpNo: e.target.value})})} />
          </InlineInputControlRow>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>Container Status</span>} />
      </div>

      <MblMilestoneContainerStatus
        isView={isView}
        selectedIndex={selectedIndex}
        status={selectedIndex >= 0 && selectedIndex < containerInfo.length ? mbl.milestone?.eventItemList?.filter(v =>  v.cntrNo === containerInfo[selectedIndex].containerNo || (v.pimsCntrId > 0 && v.pimsCntrId === containerInfo[selectedIndex].pimsLinkId)) ?? null : null}
        applyToAll={applyContainerStatusToAll}
        onChange={onContainerStatusChange}
        tableStorage={tableStorage}
        // defaultStatus={containerInfo.length > 0 ? mbl.milestone?.eventItemList?.filter(v => v.cntrNo === containerInfo[0].containerNo || v.pimsCntrId === containerInfo[0].pimsLinkId)??null : null}
        mbl={mbl}
      />
    </div>
  );
};

const MblMilestone = React.forwardRef(MblMilestoneImpl);

export default React.memo(MblMilestone);